import type { Achievement } from "../achievement.types";

export const turnedAroundAchievement: Achievement = {
  id: "turnedAround",
  name: "Turned Around",
  icon: "compass-off-outline",
  description: "Gave up further from the target than where you started.",
  isProgressive: true,
  // Rule unchanged from v1's Forgot My Keys (spec 2026-10-20 §3.2).
  check: (gameReport, gameStatus) => {
    if (
      gameStatus !== "given_up" ||
      !gameReport ||
      !gameReport.suggestedPath ||
      !gameReport.optimalPath ||
      gameReport.suggestedPath.length === 0 ||
      gameReport.optimalPath.length === 0
    ) {
      return false;
    }
    // Hops of the Local Optimal route from the final word against the gold
    // path's hops (the best route from the start).
    return gameReport.suggestedPath.length > gameReport.optimalPath.length;
  },
};
